module.exports = __webpack_public_path__ + "shopping.svg?11fcb76f06b3d2ad72f381e42aca05ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopping.svg
// module id = 120
// module chunks = 0